import useSWRInfinite from 'swr/infinite';
import { get } from '@/utils/client';
import { COLLABORATION_NOTIFICATIONS } from '@/routes/apiEndpoints';
import { useState } from 'react';

const getKey = (pageIndex, previousPageData, requestParams, limit) => {
    // Reached the end
    if (previousPageData && !previousPageData.data) return null;

    // First page, we don't have `previousPageData`
    if (pageIndex === 0) {
        return [`${COLLABORATION_NOTIFICATIONS}?per_page=${limit}`, JSON.stringify(requestParams)];
    }

    return [
        `${COLLABORATION_NOTIFICATIONS}?per_page=${limit}&cursor=${previousPageData.cursor}`,
        JSON.stringify(requestParams)
    ];
};

const useCollaborationNotifications = ({ limit = 20, params = {}, options = {} }) => {
    const [requestParams, setRequestParams] = useState(params);

    const {
        data: notifications,
        size,
        setSize,
        mutate: mutateNotifications,
        error: notificationsError,
        isValidating
    } = useSWRInfinite(
        (pageIndex, previousPageData) => getKey(pageIndex, previousPageData, requestParams, limit),
        ([url]) => get(url, requestParams)?.then((res) => res?.data),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    const isLoadingInitialData = !notifications && !notificationsError;
    const isLoadingMore =
        size > 0 && notifications && typeof notifications?.[size - 1] === 'undefined';

    return {
        notifications,
        mutateNotifications,
        notificationsError,
        requestParams,
        setRequestParams,
        isValidating,
        isLoading: !notifications && !notificationsError,
        loadMoreNotifications: () => setSize(size + 1), // Function to load more albums (load more button)
        isLoadingInitialData, // Check if it's the initial loading (not the load more)
        isLoadMore:
            notifications && typeof notifications?.[notifications?.length - 1]?.cursor === 'string', // Check if there is a cursor to active the load more button
        isLoadingMore // Check if the load more is loading
    };
};
export default useCollaborationNotifications;
